import { Button, SpinningLoader } from "risa-oasis-ui_v2";
import { InfoIcon } from "../../../../svg/info-icon";
import PdfRender from "../../../pdfRender/pdfRender";

interface DocumentTabProps {
  pdfUrl: string | null;
  isLoading: boolean;
  identifier?: string;
  onRefresh: () => void;
}

const DocumentTab = ({
  pdfUrl,
  isLoading,
  identifier,
  onRefresh,
}: DocumentTabProps) => {
  return (
    <div className="flex h-full w-full flex-col">
      {isLoading ? (
        <div className="flex h-full w-full items-center justify-center gap-4">
          <SpinningLoader />
          <p className="text-gray-600">Loading document...</p>
        </div>
      ) : pdfUrl ? (
        <PdfRender file={pdfUrl} />
      ) : (
        <div className="flex h-full w-full flex-col items-center justify-center gap-3">
          <div className="flex flex-row items-center justify-center gap-2">
            <InfoIcon height="24" width="24" stroke="#0056D6" />
            <div className="text-gray-600">No document available</div>
          </div>
          <Button
            buttonType="secondary"
            size="small"
            disabled={!identifier}
            onClick={onRefresh}
          >
            Refresh
          </Button>
        </div>
      )}
    </div>
  );
};

export default DocumentTab;
